/* eslint-disable react-hooks/rules-of-hooks */
import axios from 'axios'
import { clearAllStorages, navigateHome, setTokensInLocalStorage } from 'src/API/Actions'
import { msalInstance, loginRequest } from 'src/auth/msal'
import { setDisplayMessage } from './slices/login.slice'

//  ! Removing Cancel Token Since It Is Deprecated.
// const cancelTokenSource = axios.CancelToken.source()

// * Signal Method To Implement the Abort Action
const abortController = new AbortController()
const signal = abortController.signal

// Function to retrieve configIDs from localStorage
const getConfigIDsFromLocalStorage = () => {
  const configIDs = localStorage.getItem('configIDs')
  return configIDs
}

const axiosclient = axios.create({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accesstoken')}`,
  },
  baseURL: import.meta.env.VITE_API_URL,
  // cancelToken: cancelTokenSource.token,
  signal: signal,
})

axiosclient.interceptors.request.use(
  (request) => {
    // request.headers.Authorization = `Bearer ${localStorage.getItem('accesstoken')}`
    // let v = request.headers.Authorization.split(' ')
    // if (v[1] === 'null') {
    //   request.headers.Authorization = `Bearer ${localStorage.getItem('accesstoken')}`
    // }

    request.headers.Authorization = `Bearer ${localStorage.getItem('accesstoken')}`

    //***** Using LocalStorage *****//
    // Retrieve config Ids from localStorage
    const configIDs = getConfigIDsFromLocalStorage()
    if (configIDs) {
      // Set the configIds array directly in the header
      request.headers['config-ID'] = configIDs
      // console.log("AxiosClient", configIDs);
    }
    //***** Using LocalStorage *****//

    return request
  },
  (error) => {
    console.log('request error', error)
    return Promise.reject(error)
  },
)


const responseInterceptor = axiosclient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    // *Return For Aborted Calls
    if (error.name === 'CanceledError') {
      // Request Was Aborted , Nothing to be done
      return
    }
    const status = parseInt(error?.statusCode || error?.status || error?.response?.status)
    switch (status) {
      case 401:
        // Attempt silent token renewal once before hard logout
        if (!error.config?._retry) {
          error.config._retry = true
          try {
            await attemptSilentLogin()
            error.config.headers.Authorization = `Bearer ${localStorage.getItem('accesstoken')}`
            return axiosclient(error.config) // retry original request with fresh token
          } catch {
            // Silent renewal failed — fall through to hard logout
          }
        }
        cancelAllRequests()
        break
      case 403:
        return Promise.resolve(error.response)
      default:
        // console.log('Error:', error)
        return Promise.reject(error)
    }
  },
)

export const AxiosClient = async (type, api, payload, toolkit, responseType) => {
  try {
    const requestConfig = {
      url: api,
      method: type,
      data: payload?.signal
        ? payload.request
        : payload?.isShowProgress
          ? payload?.formData
          : payload,
      // cancelToken: cancelTokenSource.token,
      signal: payload?.signal || signal,
      onUploadProgress: payload?.onUploadProgress ? payload?.onUploadProgress : () => { },
      onDownloadProgress: payload?.onDownloadProgress ? payload?.onDownloadProgress : () => { },
    }

    if (responseType) {
      requestConfig.responseType = responseType
    }

    const response = await axiosclient(requestConfig)

    if (response.status === 200 || response.status === 201 || response.status === 202) {
      return toolkit.fulfillWithValue(response.data)
    } else if (response.status === 299) {
      return toolkit.fulfillWithValue({ data: response.data, status: response.status })
    } else if (response.status === 403) {
      toolkit.dispatch(
        setDisplayMessage({
          message: response?.data?.message || 'Access Denied',
          type: 'error',
          autoHide: false,
        }),
      )
      return toolkit.rejectWithValue(
        response?.request?.responseType === 'blob'
          ? { message: 'Access Denied' }
          : { message: response.data.message, statusCode: 403 },
      )
    } else {
      return toolkit.rejectWithValue(response.data || response.Data)
    }
  } catch (error) {
    return toolkit.rejectWithValue(
      toolkit.isRejectWithErrorMsg ? error.response.data : error.message,
    )
  }
}

export const cancelAllRequests = async () => {
  // cancelTokenSource.cancel('All requests cancelled by the user.')
  abortController.abort()
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name)
      })
    })
  }
  sessionStorage.removeItem('persist:root')
  clearAllStorages()
  window.onbeforeunload = null
  const redirectParam = window.location.hash ? '&redirect=' + encodeURIComponent(window.location.hash) : ''
  window.location.href = '/?sessionExpired=true' + redirectParam
  console.log('Request aborted')
}

const attemptSilentLogin = async () => {
  // Check if the user is logged in
  const account = msalInstance.getActiveAccount()
  if (account) {
    // Attempt silent token acquisition using the correct API scope
    const loginResponse = await msalInstance.acquireTokenSilent({
      scopes: loginRequest.scopes,
      account: account,
    })
    // Store the new IdToken directly — the API validates IdTokens
    // The 401 interceptor will retry the original request with this fresh token
    localStorage.setItem('accesstoken', loginResponse.idToken)
  } else {
    // No MSAL account found — prompt interactive login
    const loginResponse = await msalInstance.loginPopup({
      scopes: loginRequest.scopes,
    })
    msalInstance.setActiveAccount(loginResponse.account)
    localStorage.setItem('accesstoken', loginResponse.idToken)
  }
}
